import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=781f911b&scoped=true&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirmation.vue?vue&type=style&index=0&id=781f911b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f911b",
  null
  
)

export default component.exports